import { ApiErrorResponse, ApiIndividualResponse } from '@/types/api'
import { Playbook } from '@/types/playbook'
import { UseQueryResult } from '@tanstack/react-query'
import { createContext } from 'react'

export type PlaybookQueryContextType = UseQueryResult<
  ApiIndividualResponse<Playbook>,
  ApiErrorResponse
> & {
  title: string | undefined
  setTitle: (title: string) => void
}

export const PlaybookQueryContext = createContext<
  PlaybookQueryContextType | undefined
>(undefined)
